import { render, staticRenderFns } from "./EventoSharedTickets.vue?vue&type=template&id=0ac13aae"
import script from "./EventoSharedTickets.vue?vue&type=script&setup=true&lang=js"
export * from "./EventoSharedTickets.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports